module.exports = "pegasus_template/assets/spacer.gif";